import { useMemo } from "react";
import { getUser } from "auth/Authentication";

/**
 * Returns true if the user's trial has expired OR their paid subscription has expired.
 * - Trial: user.type === "2" and current time > user.trial_expiry
 * - Subscription: user.type === "2" and user.expiryTime is present but falsy (expired)
 */
export function useTrialExpiry(): boolean {
  const isExpired = useMemo(() => {
    const user = getUser();
    if (!user || user.type !== "2") return false;

    // Check paid subscription expiry first
    if (user.hasOwnProperty("expiryTime")) {
      return !user.expiryTime; // expiryTime falsy = expired
    }

    // Fall back to trial expiry
    if (user.trial_expiry) {
      const currentTimeUTC = new Date().toISOString();
      return currentTimeUTC > user.trial_expiry;
    }

    return false;
  }, []);

  return isExpired;
}
